import type { PortOption, TripType } from "@/types/search";


export type SearchErrors = {
  origin: boolean;
  destination: boolean;
  departDate: boolean;
  returnDate: boolean;
  passenger: boolean;
};

export type ValidationResult = {
  valid: boolean;
  errors: SearchErrors;
  message: string;
};

type Params = {
  origin?: PortOption;
  destination?: PortOption;
  departDate?: Date;
  returnDate?: Date;
  tripType: TripType;
  totalPax: number;
};

export function validateSearchForm({
  origin,
  destination,
  departDate,
  returnDate,
  tripType,
  totalPax,
}: Params): ValidationResult {
  const errors: SearchErrors = {
    origin: !origin,
    destination: !destination,
    departDate: !departDate,
    returnDate:
      tripType === "return" &&
      (!returnDate || (!!departDate && returnDate < departDate)),
    passenger: totalPax < 1,
  };

  let message: string | undefined;

  if (errors.origin) {
    message = "Please select origin";
  } else if (errors.destination) {
    message = "Please select jetty";
  } else if (errors.departDate) {
    message = "Please select departure date";
  } else if (errors.returnDate) {
    message = !returnDate
      ? "Please select return date"
      : "Return date cannot be before departure date";
  } else if (errors.passenger) {
    message = "Please select passenger";
  }

  return {
    valid: !message,
    errors,
    message: message || "",
  };
}
